/**
 * @ngdoc services
 * @memberof mercury.modules.stock
 * @name StockItems
 */
angular.module('mercury.modules.stock.item')
.factory('StockItems', ["$resource", "$q", "StockRecipes", "settings", function($resource, $q, StockRecipes, settings) {
  
  var StockItems = $resource(settings.apiHost + '/r/StockItems/:id', {id: '@id'}, {update: {method: 'PUT'}, patch: {method: 'PATCH'}});
  
  var StockItemSuppliers = $resource(settings.apiHost + '/r/StockItemSuppliers/:id');
  var StockMasterSupplierItems = $resource(settings.apiHost + '/r/StockMasterSupplierItems/:id');

  // New Stock API requests
  var Items = $resource(`${settings.stockHost}/internal/items/:id`, {id: '@id'})

  /**
   * [getAll description]
   *
   * @memberof StockItems
   * @return {?} [description]
   */
  function getAll() {
    return StockItems.query();
  }

  const getAllStockApi = (from, to) => Items.query({from, to});

  const getByIds = (ids) => Items.query({ids})

  /**
   * [getAllActive description]
   *
   * @memberof StockItems
   * @param  {?} date [description]
   * @return {?}      [description]
   */
  function getAllActive(date) {
    if (date) {
      return StockItems.query({$filter: 'DatestampRemoved eq null or DatestampRemoved gt ' + date});
    } else {
      return StockItems.query({$filter: 'DatestampRemoved eq null'});
    }
  }

  /**
   * [getAllWithRecipes description]
   *
   * @memberof StockItems
   * @return {?} [description]
   */
  function getAllWithRecipes() {
    var stockItemOptions = this.getAllActive();
    var recipeOptions = StockRecipes.getAllActive();

    var deferred = $q.defer();

    $q.all([
      stockItemOptions.$promise,
      recipeOptions.$promise
    ]).then(function() {
      var lineOptions = [];

      angular.forEach(stockItemOptions, function(item) {
        lineOptions.push({
          name: item.name,
          id: item.id,
          group: item.groupName,
          unitId: item.orderingUnitId,
          unitName: item.orderingUnitName,
          unitRatio: item.orderingUnitRatio,
          currentPrice: item.currentPrice,
          salesTaxRateId: item.globalSalesTaxRate,
          isRecipe: false
        });
      });

      angular.forEach(recipeOptions, function(recipe) {
        lineOptions.push({
          name: recipe.name,
          id: recipe.id,
          group: 'Recipes',
          unitId: recipe.currentVersionYeildUnitId,
          unitName: recipe.currentVersionYeildUnitName,
          unitRatio: recipe.currentVersionYeildUnitRatio,
          currentPrice: recipe.currentPrice,
          isRecipe: true
        });
      });

      deferred.resolve(lineOptions);
    }, function(response) {
      deferred.reject(response);
    });

    return deferred.promise;
  }

  /**
   * [get description]
   *
   * @memberof StockItems
   * @param  {?} id [description]
   * @return {?}    [description]
   */
  function get(id, dateFor) {
    var params = {id: id};
    if (dateFor) {
      params.stockCostDate = dateFor;
    }
    return StockItems.get(params);
  }

  const getStockApi = (id, includeDeleted) => Items.get({ id, includeDeleted })

  /**
   * [getItemSupplier description]
   *
   * @memberof StockItems
   * @param  {?} itemId     [description]
   * @param  {?} unitId     [description]
   * @param  {?} supplierId [description]
   * @param  {?} brandId    [description]
   * @return {?}            [description]
   */
  function getItemSupplier(itemId, unitId, supplierId, brandId) {
    var deferred = $q.defer();

    if (!supplierId) {
      deferred.resolve(null);
    } else {
      var query = [
        'StockItemId eq ' + itemId,
        'UnitId eq ' + unitId,
        'SupplierId eq ' + supplierId
      ];

      if (brandId) {
        query.push('BrandId eq ' + brandId);
      } else {
        query.push('BrandId eq null');
      }

      StockItemSuppliers.query({'$filter': query.join(' and ')})
      .$promise.then(function(result) {
        if (result.length > 0) {
          deferred.resolve(result[0]);
        } else {
          deferred.resolve(null);
        }
      }, function(response) {
        deferred.reject(response);
      });
    }

    return deferred.promise;
  }

  /**
   * [searchStockcodes description]
   *
   * @memberof StockItems
   * @param  {?} searchStr  [description]
   * @param  {?} supplierId [description]
   * @param  {?} limit      [description]
   * @return {?}            [description]
   */
  function searchStockcodes(searchStr, supplierId, limit) {
    var params = {searchStr: searchStr, supplierId: supplierId};

    if (limit) {
      params.limit = limit;
    }

    return StockMasterSupplierItems.query(params);
  }

  /**
   * [newCustom description]
   *
   * @memberof StockItems
   * @param  {?} fields [description]
   * @return {?}        [description]
   */
  function newCustom(fields) {
    return StockItems.save(fields).$promise;
  }

  /**
   * [newMaster description]
   *
   * @memberof StockItems
   * @param  {?} masterItemId [description]
   * @return {?}              [description]
   */
  function newMaster(masterItemId) {
    return StockItems.save({
      masterId: masterItemId
    }, {}).$promise;
  }

  /**
   * [patch description]
   *
   * @memberof StockItems
   * @param  {?} itemId   [description]
   * @param  {?} field    [description]
   * @param  {?} newValue [description]
   * @return {?}          [description]
   */
  function patch(itemId, field, newValue) {
    var delta = [{op: 'replace', path: field, value: newValue}];

    return StockItems.patch({id: itemId}, delta).$promise;
  }

  /**
   * [remove description]
   *
   * @memberof StockItems
   * @param  {?} item [description]
   * @return {?}      [description]
   */
  function remove(item) {
    return patch(item.id, 'DatestampRemoved', moment().format());
  }

  /**
   * [restore description]
   *
   * @memberof StockItems
   * @param  {?} item [description]
   * @return {?}      [description]
   */
  function restore(item) {
    return patch(item.id, 'DatestampRemoved', null);
  }

  /**
   * [update description]
   *
   * @memberof StockItems
   * @param  {?} item [description]
   * @return {?}      [description]
   */
  function update(item) {
    return Items.update(item).$promise;
  }

  /**
   * [setItemSupplier description]
   *
   * @memberof StockItems
   * @param {?} itemId     [description]
   * @param {?} supplierId [description]
   * @param {?} unitId     [description]
   * @param {?} brandId    [description]
   * @param {?} stockCode  [description]
   * @param {?} unitCost   [description]
   */
  function setItemSupplier(itemId, supplierId, unitId, brandId, stockCode, unitCost) {
    var stockcode = {
      stockItemId: itemId,
      supplierId: supplierId,
      unitId: unitId,
      brandId: brandId,
      stockCode: stockCode,
      unitCost: unitCost
    };

    return StockItemSuppliers.save(stockcode).$promise;
  }

  return {
    getAll: getAll,
    getAllActive: getAllActive,
    getAllWithRecipes: getAllWithRecipes,
    get: get,
    getByIds: getByIds,
    getItemSupplier: getItemSupplier,
    searchStockcodes: searchStockcodes,
    newCustom: newCustom,
    newMaster: newMaster,
    remove: remove,
    restore: restore,
    update: update,
    patch: patch,
    setItemSupplier: setItemSupplier,
    getAllStockApi,
    getStockApi
  };
}]);
